import React from "react";
import PhishingAnalysis from "../components/PhishingAnalysis/PhishingAnalysis";
import "./PhishingAnalysisPage.css";

export default function PhishingPage() {
  return (
    <div className="phishing-pages">
      <header className="header">
      </header>
      <PhishingAnalysis />
    </div>
  );
}
